import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-footer',
    templateUrl: './modal-footer.component.html',
    styleUrls: ['./modal-footer.component.scss'],
    standalone: false
})
export class ModalFooterComponent {

}

